export default __webpack_public_path__ + "static/media/pic6.b674928d.jpg";